import axios, { defaultParams } from './axios';
export default function put(url, body, config) {
    const mergedConfig = { ...defaultParams(), ...(config ?? {}) };
    return axios.put(url, body, mergedConfig);
}
